import classNames from 'classnames';
import React from 'react';
import Typography from '@/components/atoms/typography/typography';
import GenericAccordion from '@/components/organisms/generic-accordion/generic-accordion';
import { useWindowSize } from '@/libraries/hooks/use-window-size';
import styles from './destination-facts-table.module.scss';

export interface DestinationFactsTableProps {
  /** The content inside the table */
  children?: React.ReactNode;
  /** The class name to apply */
  className?: string;
  /** The text to show as a headline */
  headline?: string;
}

const DestinationFactsTable = ({
  className,
  children,
  headline,
}: DestinationFactsTableProps) => {
  const isTablet = useWindowSize('tablet');

  return (
    <div className={classNames(styles.component, className)}>
      {isTablet ? (
        <React.Fragment>
          <Typography className={styles.tableHeadline} tagStyle="labelMedium">
            {headline}
          </Typography>

          {children}
        </React.Fragment>
      ) : (
        <GenericAccordion headline={headline ?? ''}>
          {children}
        </GenericAccordion>
      )}
    </div>
  );
};

DestinationFactsTable.displayName = 'DestinationFactsTable';

export default DestinationFactsTable;
